import type { SearchSuggestion } from '../types';
import type { MBDParams } from '@shared/types/frontend/meaningful-behaviour-data';
import type { FormatDate } from '@shared/types/i18n/localisation-service';
import type { UserContext } from '@shared/types/user-context';
import type { Maybe } from '@shared/types/utils';
import type { Destination } from '@shared/ui/types';

import {
  MBD_ITEMS,
  MBD_TYPE,
} from '@shared/constants/meaningful-behaviour-data';
import { ENTITY_TYPE } from '@shared/utils-frontend/mini-events/constants';

type SearchSubmitButtonParams = {
  userContext: UserContext;
  formatDate: FormatDate;
  destination?: Destination | SearchSuggestion;
  checkInDate: Maybe<Date>;
  checkOutDate: Maybe<Date>;
  adults: number;
  childrenAges: number[];
  rooms: number;
};

const buildSearchSubmitButtonAttributes = (
  btnParams?: SearchSubmitButtonParams,
) => {
  if (!btnParams) {
    return {
      ...MBD_ITEMS[MBD_TYPE.SEARCH_BUTTON],
    };
  }
  const {
    adults,
    checkInDate,
    checkOutDate,
    childrenAges,
    destination,
    formatDate,
    rooms,
    userContext,
  } = btnParams as SearchSubmitButtonParams;
  const entityType = ENTITY_TYPE[destination?.type?.toUpperCase() ?? ''];
  const checkInDateStr = checkInDate
    ? formatDate(checkInDate, 'yyyy-MM-dd')
    : '';
  const checkOutDateStr = checkOutDate
    ? formatDate(checkOutDate, 'yyyy-MM-dd')
    : '';
  const guests = adults + childrenAges.length;
  const pageName = userContext.pageType;

  const params: MBDParams = {
    guests,
    rooms,
    entity_type: entityType,
    check_in_date: checkInDateStr,
    check_out_date: checkOutDateStr,
    page_name: pageName,
  };

  return {
    ...MBD_ITEMS[MBD_TYPE.SEARCH_BUTTON],
    params,
  };
};

export { buildSearchSubmitButtonAttributes };
